import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { CircledCheckmarkIcon, AlertIcon } from '../../atoms/Icons';

const FEEDFLO_SMS_NUMBER = '(204) 262-1928';

function TransportStatus({ transportId, details }) {
  if (!details?.sent_at) {
    return null;
  }

  const secondsSinceSent = Math.floor(Date.now() / 1000 - details.sent_at);
  const messageSinceSent = `${dayjs.duration(secondsSinceSent, 'seconds').humanize()} ago`;

  // Success status
  if (details.status === 'success') {
    return (
      <div className="TransportMethodSelector-optionStatus TransportMethodSelector-optionStatus--success">
        <CircledCheckmarkIcon className="TransportMethodSelector-statusIcon" />
        Success {messageSinceSent}
      </div>
    );
  }

  // Pending status
  if (details.status === 'pending') {
    const pendingMessages = {
      sms: `Sent successfully, delivery pending ${messageSinceSent}`,
      email: `Email accepted, delivery pending ${messageSinceSent}`,
      push: `Pending ${messageSinceSent}`,
    };
    const message = pendingMessages[transportId] || `Pending ${messageSinceSent}`;

    return (
      <div className="TransportMethodSelector-optionStatus TransportMethodSelector-optionStatus--pending">
        {message}
      </div>
    );
  }

  // Error status - check for specific error types
  if (details.errorMessage?.includes('unsubscribed') || details.status === 'unsubscribed') {
    const phoneNumberDigits = FEEDFLO_SMS_NUMBER.replace(/\D/g, '');
    return (
      <div className="TransportMethodSelector-optionStatus TransportMethodSelector-optionStatus--error">
        <AlertIcon className="TransportMethodSelector-statusIcon" />
        Your phone number is currently unsubscribed from SMS notifications. To enable notifications, text
        &quot;START&quot; to{' '}
        <a href={`sms://${phoneNumberDigits}?body=START`} className="TransportMethodSelector-phoneLink">
          {FEEDFLO_SMS_NUMBER}
        </a>
        .
      </div>
    );
  }

  // Generic error
  return (
    <div className="TransportMethodSelector-optionStatus TransportMethodSelector-optionStatus--error">
      <AlertIcon className="TransportMethodSelector-statusIcon" />
      {details.errorMessage || `Error ${messageSinceSent}`}
    </div>
  );
}

TransportStatus.propTypes = {
  transportId: PropTypes.string.isRequired,
  details: PropTypes.shape({
    sent_at: PropTypes.number,
    status: PropTypes.string,
    errorMessage: PropTypes.string,
  }),
};

export default TransportStatus;
